import service from '@/utils/request'

// 1、返回一个唯一标识符
export const jsuuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export const getWeek = (DTTM) => {
  const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  const date = new Date(DTTM)
  const weekday = date.getDay()
  return weekDays[weekday]
}

// uuid2
export const jsuuid2 = (len, radix) => {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  radix = radix || chars.length

  if (len) {
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | Math.random() * radix]
    }
  } else {
    var r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

// 时间字符串
export const uuid = () => {
  var d = new Date()
  return (
      d.getFullYear() + "-" +
      (d.getMonth() + 1) + "-" +
      d.getDate() + "-" +
      d.getHours() + "-" +
      d.getMinutes() + "-" +
      d.getSeconds()
  )
}

// 带参数的数据集
export const paramData2 = (url, key, value, key2, value2, table) => {
  return service(url, {
    method: 'post',
    data: {
      p_key: key,
      p_value: value,
      p_key2: key2,
      p_value2: value2,
      p_table: table
    }
  })
}

export const paramData = (url, key, value, key2, value2, table, cond) => {
  return service(url, {
    method: 'post',
    data: {
      p_key: key,
      p_value: value,
      p_key2: key2,
      p_value2: value2,
      p_table: table,
      p_cond: cond
    }
  })
}

const getHandledValue = (num) => {
  return num < 10 ? '0' + num : num
}

// 当前日期
export const getDate = (startType) => {
  const d = new Date()
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())

  if (startType === 'year')
    return `${year}-${month}-${date}-${hours}-${minutes}-${second}`
  else if (startType === 'full')
    return `${year}-${month}-${date} ${hours}:${minutes}:${second}`
  else if (startType === 'yr')
    return `${year}`
  else if (startType === 'month')
    return `${year}-${month}`
  else
    return `${year}-${month}-${date}`
}

export const getDate2 = (day) => {
  const d = new Date(new Date().getTime() - day * 24 * 60 * 60 * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  return `${year}-${month}-${date}`
}

export const getCurrentDay = () => {
  const d = new Date()
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
}

export const baseCascade = (url, value) => {
  return service(url, {
    method: 'post',
    data: {
      p_key: 'parentno',
      p_value: value,
      p_table: 'v_sys_base'
    }
  })
}

export const format_number = (n) => {
  var str_n = n.toString()
  var result = ""
  while (str_n.length > 3) {
    result = "," + str_n.slice(-3) + result
    str_n = str_n.slice(0, str_n.length - 3)
  }
  if (str_n) {
    return str_n + result
  }
}

export const getDaysDifference = (dateString1, dateString2) => {
  if (!dateString1 || !dateString2) {
    return ""
  }

  var date1 = new Date(dateString1)
  var date2 = new Date(dateString2)

  var difference = Math.abs(date1.getTime() - date2.getTime())
  var daysDifference = Math.round(difference / (1000 * 60 * 60 * 24))

  return daysDifference + ""
}
